import api from '@/lib/libAxios';

const API = '/api';
const AUTH = '/auth';
const UI = '/ui';

/* ---------------- Auth ---------------- */

export function getGoogleNonce() {
  return api.get(`${AUTH}/google/nonce`);
}

export function checkToken(token, nonce) {
  return api.post(`${AUTH}/signin/google`, { token, nonce });
}

export function mailLogIn(data) {
  return api.post(`${AUTH}/login/mail`, data);
}

export function mailSignIn(data) {
  return api.post(`${AUTH}/signin/mail`, data);
}

export function mailForgotPassword(data) {
  return api.post(`${AUTH}/forgot-password`, data);
}

export function mailResetPassword(data) {
  return api.post(`${AUTH}/reset-password`, data);
}

export function logOut() {
  return api.post(`${AUTH}/signout`);
}

export function changePassword(data) {
  return api.post(`${API}/changePassword`, data);
}

/* ---------------- Workouts ---------------- */

export function getAllWorkouts(params = {}) {
  const query = new URLSearchParams();

  query.set('page', params.page && params.page > 0 ? params.page : 1);
  if (params.date) query.set('date', params.date);
  if (params.gymType) query.set('gymType', params.gymType);
  if (params.muscle) query.set('muscle', params.muscle);
  if (params.exerciseName) query.set('exerciseName', params.exerciseName);
  if (params.cardioType) query.set('cardioType', params.cardioType);
  if (params.plannedWorkoutDates) query.set('plannedWorkoutDates', params.plannedWorkoutDates);
  if (params.pastWorkoutDates) query.set('pastWorkoutDates', params.pastWorkoutDates);
  return api.get(`${API}/workouts?${query.toString()}`);
}

export function getTodayWorkout() {
  const today = new Date();
  const yyyy = today.getFullYear();
  const mm = String(today.getMonth() + 1).padStart(2, '0');
  const dd = String(today.getDate()).padStart(2, '0');

  const queryParams = {
    date: `${yyyy}-${mm}-${dd}`,
    plannedWorkoutDates: true,
    pastWorkoutDates: true,
  };
  return getAllWorkouts(queryParams);
}

export function downloadXlsxWorkout(params = {}) {
  const query = new URLSearchParams();
  if (params.id) query.set('id', params.id);
  if (params.lang) query.set('lang', params.lang);
  return api.get(`${API}/workouts/download/xls?${query.toString()}`, { responseType: 'blob' });
}
export function downloadPdfWorkout(params = {}) {
  const query = new URLSearchParams();
  if (params.id) query.set('id', params.id);
  if (params.lang) query.set('lang', params.lang);
  return api.get(`${API}/workouts/download/pdf?${query.toString()}`, { responseType: 'blob' });
}
export function downloadICS() {
  return api.get(`${API}/workouts/download/ics`, { responseType: 'blob' });
}

export function createWorkout(data) {
  return api.post(`${API}/workouts`, data);
}

export function updateWorkout(data) {
  return api.put(`${API}/workouts/${data.id}`, data);
}

export function deleteWorkout(id) {
  return api.delete(`${API}/workouts/${id}`);
}

export function getTrends(period, filters) {
  return api.get(`${API}/workouts/average`, {
    params: {
      size: period, muscle: filters.muscle,
    },
  });
}

export function getTop5(period) {
  return api.get(`${API}/workouts/top5`, { params: { size: period } });
}

export function getUniqueExs() {
  return api.get(`${API}/workouts/uniq`);
}

/* ---------------- Measurements ---------------- */

export function createMeasurement(data) {
  return api.post(`${API}/measurements`, data);
}

export function getMeasurements() {
  return api.get(`${API}/measurements`);
}

/* ---------------- User Data ---------------- */

export function exportData() {
  return api.get(`${API}/user/export`, { responseType: 'blob' });
}

export function wipeData(currentPassword) {
  return api.post(`${API}/user/wipe`, { current_password: currentPassword });
}

export function deleteUser(currentPassword) {
  return api.delete(`${API}/user`, { data: { current_password: currentPassword } });
}

export function updateProfile(data) {
  return api.put(`${API}/user`, data);
}

export function loadProfile() {
  return api.get(`${API}/user`);
}

export function postfeedback(data) {
  return api.post(`${API}/user/feedback`, data);
}
export function notificationsUpdate(data) {
  return api.put(`${API}/user/notifications`, data);
}

/* ---------------- Locale ---------------- */

export async function getLocale(locale) {
  const response = await api.get(`${UI}/locales`, { params: { lang: locale } });
  return response.data;
}
